<script setup lang="ts">
import BaseButton from './BaseButton.vue';

const props = defineProps<{
  storeUrl: string;
}>();

const openAppStore = () => {
  if (props.storeUrl) window.open(props.storeUrl, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <div class="fixed inset-0 z-[100] bg-background flex items-center justify-center p-8">
    <div class="max-w-sm text-center flex flex-col items-center gap-5">
      <UIcon
        name="i-lucide-arrow-up-circle"
        class="size-14 text-primary"
      />
      <div>
        <h1 class="text-text-primary text-xl font-semibold mb-2">
          Update required
        </h1>
        <p class="text-text-secondary text-sm leading-relaxed">
          A new version of DrumbleBee is available. Please update from the App Store
          to keep playing.
        </p>
      </div>
      <BaseButton
        color="primary"
        size="lg"
        class="w-full"
        @click="openAppStore"
      >
        <span>Update now</span>
      </BaseButton>
    </div>
  </div>
</template>
